<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <section v-if="cash">
      <div v-if="cash_total_balance < 0" class="row justify-content-around">
        <div class="alert alert-secondary col-12 col-md-5" role="alert">
          <h5 class="mt-0">
            <img class="mr-3" src="/static/rd-images/banka.svg" alt="bankovní převod">
            platba bankovním převodem</h5>
          <hr>
          zpracování během 1-2 pracovních dnů
          <hr>
          <div class="d-flex">
            <div class="udaje-pro-platbu">
              <nobr>číslo účtu: <span class="mutable">344355366</span></nobr><br>
              kód banky: <span class="mutable">2010</span><br>
              <nobr>variabilní symbol: <span class="mutable">{{ $store.state.customerInfo ? $store.state.customerInfo.id : '' }}</span></nobr><br>

              <div class="text-danger" v-if="amountOverdue > 0">
                <nobr>dlužná částka (po splatnosti): <b>{{ prachy_bez_00(amountOverdue) }}</b> Kč</nobr>
              </div>
              <div v-if="amountIndue > 0">
                platba na přístí období: <span class="mutable">{{ prachy_bez_00(amountIndue) }}</span> Kč
              </div>
              <div v-if="amountOverdue > 0 && amountIndue > 0">
                <nobr>celkem: <span class="mutable"><b>{{ prachy_bez_00(amountOverdue + amountIndue) }}</b></span> Kč</nobr>
              </div>
            </div>
            <!-- QR kod zobrazovat pouze pokud je zcela jasna castka k uhrade. Pri kombinaci dluh + predpis na pristi obdobi radeji nezobrazovat. -->
            <div class="qr-platba" v-if="$store.state.customerInfo && $store.state.customerInfo.id && (amountOverdue == 0 || amountIndue == 0)">
              <img width="125px" height="125px" :src="`/api/spayd-qr-code.png?accountNumber=344355366&amp;bankCode=2010&amp;amount=${amountIndue+amountOverdue}&amp;&amp;vs=${$store.state.customerInfo.id}&amp;message=Rychly+drat+QR`">
              <br>
              <small><i>QR kód pro platbu</i></small>
            </div>
          </div>
        </div>
        <div class="alert alert-secondary col-12 col-md-6" role="alert">
          <div class="media">
            <div>
            <img class="mr-3" src="/static/rd-images/visa.png" alt="visa" width="65px">
            <br><br>
            <img class="mr-3" src="/static/rd-images/mastercard-logo.svg" alt="mastercard" height="45px">
            </div>
            <div class="media-body">
              <h5 class="mt-0">platba kartou</h5>
              <hr>
              zpracování během 15 minut
              <hr>
              <div class="text-danger" v-if="amountOverdue > 0">
                dlužná částka (po splatnosti): <b>{{ prachy_bez_00(amountOverdue) }}</b> Kč
              </div>
              <div v-if="amountIndue > 0">
                platba na přístí období: <span class="mutable">{{ prachy_bez_00(amountIndue) }}</span> Kč
              </div>
              <div v-if="onlinePaymentSurcharge !== 0">
                expresní zpracování platby: <span class="mutable">{{ prachy_bez_00(onlinePaymentSurcharge) }}</span> Kč
              </div>
              <div class="mt-3">
                <button name="pay1" type="submit" v-if="amountOverdue > 0" class="btn btn-primary mr-5" v-on:click="zaplatitKartou(amountOverdue + onlinePaymentSurcharge)" :disabled="createOrderPending">
                  Zaplatit <strong>{{ prachy_bez_00(amountOverdue+onlinePaymentSurcharge) }}</strong> Kč
                  <br>
                  <small>dlužná částka</small>
                </button>
                <button name="pay2" type="submit" v-if="amountIndue > 0" class="btn btn-info" v-on:click="zaplatitKartou(amountOverdue + onlinePaymentSurcharge + amountIndue)" :disabled="createOrderPending">
                  Zaplatit <strong>{{ prachy_bez_00(amountOverdue+onlinePaymentSurcharge+amountIndue) }}</strong> Kč
                  <br>
                  <small><span v-if="amountOverdue > 0">dlužná částka + </span>na příští období</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row justify-content-around">
        <div class="alert alert-secondary col-12 col-md-5">
          <div class="media">
            <img class="mr-3" src="/static/rd-images/banka.svg" alt="bankovní převod">
            <div class="media-body">
              <h5 class="mt-0">platba bankovním převodem</h5>
              <p>
                Platby prosím poukazujte na:<br>
                &nbsp; číslo účtu <span class="mutable">344355366</span><br>
                &nbsp; kód banky <span class="mutable">2010</span><br>
                &nbsp; variabilní symbol <span class="mutable">{{ $store.state.customerInfo ? $store.state.customerInfo.id : '' }}</span>
                <br>
                Děkujeme.
              </p>
            </div>
          </div>
        </div>
        <div class="alert alert-secondary col-12 col-md-6" role="alert">
          <div class="media">
            <div>
            <img class="mr-3" src="/static/rd-images/visa.png" alt="visa" width="65px">
            <br><br>
            <img class="mr-3" src="/static/rd-images/mastercard-logo.svg" alt="mastercard" height="45px">
            </div>
            <div class="media-body">
              <h5 class="mt-0">platba kartou</h5>
                <div class="mt-3">
                  ✅ vše zaplaceno, děkujeme.
                  <br><br>
                  <i>Platba na příští období bude předepsána {{dateNextMonthFirst}}.</i>
                </div>
            </div>
          </div>
        </div>
      </div>

      <h2>historie účtu
        <small v-if="cash.length > 10">
          <span v-if="displayLast10">
            - posledních 10 položek
            <button class="btn btn-outline-primary" v-on:click="displayLast10=false">zobrazit vše</button>
          </span>
          <span v-else>
            - vše od {{human_readable_date(cash[0].createTs)}}
          </span>
        </small>
      </h2>
      <table class="table table-sm">
        <thead>
          <tr>
            <th>
              datum účtování
            </th>
            <th>
              datum splatnosti
            </th>
            <th class="money">
              k&nbsp;úhradě
            </th>
            <th class="money">
              uhrazeno
            </th>
            <th class="money">
              zůstatek
            </th>
            <th>
              popis
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in (displayLast10 ? cash.slice(-10) : cash)" :key="item.id">
            <td style="width: 7%">
              {{ human_readable_date(item.createTs) }}
            </td>
            <td style="width: 7%">
              <span v-if="item.value < 0">
                {{ human_readable_date(item.date) }}
              </span>
            </td>
            <td class="money" style="width: 7%">
              <span v-if="item.value < 0">
                {{ prachy(-item.value) }}
              </span>
            </td>
            <td class="money" style="width: 7%">
              <span v-if="item.value >= 0">
                {{ prachy(item.value) }}
              </span>
            </td>
            <td v-bind:class="{'number-below-zero': item.after < 0 }" class="money"  style="width: 7%">
              {{ prachy(item.after) }}
            </td>
            <td style="width: 65%">
              {{ item.comment }}
              <div class="comment2" v-if="item.comment2">{{ item.comment2 }}</div>
            </td>
          </tr>
          <tr class='bottomline'>
            <td />
            <td />
            <td />
            <td />
            <td v-bind:class="{'number-below-zero': cash_total_balance < 0}" class="money">
              {{ prachy(cash_total_balance) }}
            </td>
            <td class="preplatek-nebo-nedoplatek">
              <span v-if="cash_total_balance == 0">
                ✅ vše zaplaceno, děkujeme.
              </span>
              <span v-else-if="cash_total_balance > 0">
                ✅ (máte přeplaceno)
              </span>
              <span v-else>
                  <div>částka k úhradě je {{ prachy(-cash_total_balance) }} Kč</div>
                  <div v-if="overdueAmount>0" class="number-below-zero">
                    z toho {{ prachy(overdueAmount) }} Kč je již po splatnosti
                  </div>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import CashResource from '../backend-resources/cash-resource'
import GpWebpayResource from '../backend-resources/gp-webpay-resource'
import moment from 'moment'

export default {
  name: 'my-account',
  data () {
    return {
      cash: null,
      cash_total_balance: null,
      displayError: null,
      displayLast10: true,
      isLoading: false,
      onlinePaymentConfig: {surcharge: 0},
      createOrderPending: false
    }
  },
  created: function () {
    this.loadCashEntries()
    this.loadOnlinePaymentConfig()
  },
  methods: {
    loadCashEntries () {
      this.isLoading = true
      CashResource.get().then((cash) => {
        this.isLoading = false
        this.cash = cash.data
        this.cash_total_balance = this.cash[this.cash.length - 1].after
        this.displayError = null
      }).catch((error) => {
        this.isLoading = false
        this.displayError = error.response.status + ' ' + error.response.statusText
        this.cash = null
        this.cash_total_balance = null
      })
    },
    loadOnlinePaymentConfig () {
      CashResource.get_online_payment_config().then((result) => {
        this.onlinePaymentConfig = result.data
      })
    },
    human_readable_date: function (yyyymmdd) {
      let m = moment(yyyymmdd)
      return m.isValid() ? m.format('D.M.Y') : yyyymmdd
    },
    prachy: function (kolik) {
      if (kolik === null) return ''
      kolik = parseFloat(kolik)
      return kolik.toFixed(2)
    },
    prachy_bez_00: function (kolik) {
      if (kolik === null) return ''
      kolik = parseFloat(kolik)
      if (kolik.toFixed(2).endsWith('.00')) {
        return kolik.toFixed(0)
      } else {
        return kolik.toFixed(2)
      }
    },
    zaplatitKartou (amount) {
      this.createOrderPending = true
      GpWebpayResource.createOrder({amount: amount})
        .then((result) => {
          if (result.data.goto.startsWith('http')) {
            window.location = result.data.goto
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.displayError = 'Litujeme, platební brána je dočasně nedostupná. Zkuste to prosím později.'
          } else {
            this.displayError = error.response.status + ' ' + error.response.statusText
          }
          this.createOrderPending = false
        })
    }
  },
  computed: {
    overdueAmount () {
      if (!this.$store.state.cashTotals) return 0
      if (this.$store.state.cashTotals.overdue_amount === undefined) return 0
      return parseFloat(this.$store.state.cashTotals.overdue_amount).toFixed(2)
    },
    amountOverdue () {
      let amount = this.overdueAmount
      amount = Math.round(amount * 100) / 100
      return amount > 0 ? amount : 0
    },
    amountIndue () {
      let amount = -(this.cash_total_balance - (-this.overdueAmount))
      amount = Math.round(amount * 100) / 100
      return amount > 0 ? amount : 0
    },
    onlinePaymentSurcharge () {
      return this.onlinePaymentConfig.surcharge
    },
    last10cashEntries () {
      return this.cas.slice(-10)
    },
    dateNextMonthFirst () {
      return moment().endOf('month').add(1, 'd').format('D.M.Y')
    }
  }
}
</script>

<style scoped>
.btn {
  font-size: 100%;
}
.number-below-zero {
  color: red;
}
.bottomline {
  font-weight: bold;
}
tr.bottomline {
  border-top: 1px solid
}
.money {
  text-align: right;
}
.preplatek-nebo-nedoplatek {
  font-weight: normal;
  font-style: italic;
}
.mutable {
  color: darkblue;
}
.udaje-pro-platbu {
  line-height: 1.75;
}
.qr-platba {
  margin-left: 1rem;
  margin-top: -0.75rem;
}
.comment2 {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// MyAccount.vue?4dc97d8a